import React from 'react';
import styled from 'styled-components';
import { Logo as DefaultLogo } from 'prospect-path-components';
import { Button } from 'prospect-path-base';
import Logo from '../../../img/logo.svg';

const HeaderContainer = styled.header`
  padding: 1rem 2rem;
  display: flex;
  align-items: center;
`

const HeaderAction = styled.div`
  display: flex;
  margin-left: auto;
`

const Header = ({ showLogInButton = true }) => (
    <HeaderContainer>
        <div>
            <img src={Logo} alt='Prospect Path Logo'/>
        </div>
        <HeaderAction>
            {showLogInButton ? <Button size="small" color="secondary">
                <a href={'/login'} style={{ textDecoration: 'none', color: 'black' }}>Log in</a>
            </Button> : ''}
        </HeaderAction>
    </HeaderContainer>
)

export default Header;
